import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { BRAND_LOGO } from '../../constants/brand';

const sizeClasses = {
  sm: 'h-[1.125rem]',
  md: 'h-6',
  lg: 'h-9',
  hero: 'h-12 md:h-24',
};

/**
 * Lockup horizontal oficial GFI LATINO.
 * Variante clara u oscura según el tema activo.
 */
export default function BrandLogo({ size = 'md', className = '' }) {
  const { isDark } = useTheme();
  const heightClass = sizeClasses[size] || sizeClasses.md;

  return (
    <img
      src={isDark ? BRAND_LOGO.dark : BRAND_LOGO.light}
      alt="GFI Latino"
      className={`${heightClass} w-auto object-contain ${className}`}
    />
  );
}
